import { useEffect, useState } from "react";
import { getCustomers } from "../services/customerService";

export default function useCustomers() {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadCustomers = async () => {
    try {
      setLoading(true);

      const data = await getCustomers();
      const customerLists = data?.customers || [];
      setCustomers(customerLists);
    } catch (err) {
      console.error("Failed to fetch customers", err);
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadCustomers();
  }, []);

  return {
    customers,
    loading,
    error,
    refetch: loadCustomers,
  };
}
